import type React from "react";
import type { VariantProps } from "./types";
import { VariantEditorial } from "./editorial";
import { VariantMagazine } from "./magazine";
import { VariantPhotoLed } from "./photoled";
import { VariantCeremonial } from "./ceremonial";
import { VariantMinimal } from "./minimal";
import { VariantCelebration } from "./celebration";
import { VariantNewborn } from "./newborn";
import { VariantAgenda } from "./agenda";
import { VariantMemorial } from "./memorial";
// 10 variants (round 2)
import { BotanicalVariant } from "./botanical";
import { SeasideVariant } from "./seaside";
import { JubileeVariant } from "./jubilee";
import { EngagementVariant } from "./engagement";
import { CelebrationSunnatVariant } from "./celebration-sunnat";
import { AcademiaVariant } from "./academia";
import { AdultBirthdayVariant } from "./adult-birthday";
import { LaunchEventVariant } from "./launch-event";
import { ReverentVariant } from "./reverent";
import { RestaurantOpeningVariant } from "./restaurant-opening";
// 10 variants (round 3)
import { CorpAnniversaryVariant } from "./corp-anniversary";
import { RetailOpeningVariant } from "./retail-opening";
import { ConfTracksVariant } from "./conf-tracks";
import { MasterclassVariant } from "./masterclass";
import { CharityElegantVariant } from "./charity-elegant";
import { HousewarmingVariant } from "./housewarming";
import { SunriseWeddingVariant } from "./sunrise-wedding";
import { MilestoneBirthdayVariant } from "./milestone-birthday";
import { LoversVariant } from "./lovers";
import { IftarVariant } from "./iftar";
// 5 variants (round 4 — wedding maximalist)
import { BaroqueGoldVariant } from "./baroque-gold";
import { TulipMiniatureVariant } from "./tulip-miniature";
import { CelestialFoilVariant } from "./celestial-foil";
import { GardenCascadeVariant } from "./garden-cascade";
import { BukharaRoyalVariant } from "./bukhara-royal";
// 5 variants (round 5 — birthday maximalist)
import { KidCarnivalVariant } from "./kid-carnival";
import { PrincessCastleVariant } from "./princess-castle";
import { SparklerMilestoneVariant } from "./sparkler-milestone";
import { VintageFairVariant } from "./vintage-fair";
import { DiscoNeonVariant } from "./disco-neon";
// User-imported standalone HTML templates
import { DiyoraStaticVariant } from "./diyora-static";
import { AvgustStaticVariant } from "./avgust-static";
import { SentabrStaticVariant } from "./sentabr-static";
// Round 6 — 10 mobile-first iframe-static wedding templates
import { MehrliStaticVariant } from "./mehrli-static";
import { TilakliStaticVariant } from "./tilakli-static";
import { OlovgulStaticVariant } from "./olovgul-static";
import { BezakliStaticVariant } from "./bezakli-static";
import { IpakliStaticVariant } from "./ipakli-static";
import { SokinStaticVariant } from "./sokin-static";
import { MavjliStaticVariant } from "./mavjli-static";
import { LavandaStaticVariant } from "./lavanda-static";
import { OlchaStaticVariant } from "./olcha-static";
import { QuyoshliStaticVariant } from "./quyoshli-static";
import { BeshikToyiStaticVariant } from "./beshik-toyi-static";
// Round 7 — 5 mixed iframe-static templates
import { YubileyKorporativStaticVariant } from "./yubiley-korporativ-static";
import { UchrashuvStaticVariant } from "./uchrashuv-static";
import { BarakaliStaticVariant } from "./barakali-static";
import { AlisherMuazzamStaticVariant } from "./alisher-muazzam-static";
import { AnvarMasumaStaticVariant } from "./anvar-masuma-static";
// Round 8 — 4 designer iframe-static templates (Risograph birthday,
// editorial corporate quarterly, romantic one-question ask, cinema-
// frame editorial wedding)
import { BirthdayRisoStaticVariant } from "./birthday-riso-static";
import { CorporateQuarterlyStaticVariant } from "./corporate-quarterly-static";
import { MarryMeOneQuestionStaticVariant } from "./marry-me-one-question-static";
import { WeddingEditorialCinemaStaticVariant } from "./wedding-editorial-cinema-static";
// Round 9 — 25 bookie-style templates (premium category)
import { BookiePaperGoldStaticVariant } from "./bookie-paper-gold-static";
import { BookieSageStaticVariant } from "./bookie-sage-static";
import { BookieWineStaticVariant } from "./bookie-wine-static";
import { BookieTealStaticVariant } from "./bookie-teal-static";
import { BookieMidnightStaticVariant } from "./bookie-midnight-static";
import { BookieCopperStaticVariant } from "./bookie-copper-static";
import { BookieMauveStaticVariant } from "./bookie-mauve-static";
import { BookieEmeraldStaticVariant } from "./bookie-emerald-static";
import { BookieBlushStaticVariant } from "./bookie-blush-static";
import { BookieNavyStaticVariant } from "./bookie-navy-static";
import { BookieAmberStaticVariant } from "./bookie-amber-static";
import { BookiePearlStaticVariant } from "./bookie-pearl-static";
import { BookieTerracottaStaticVariant } from "./bookie-terracotta-static";
import { BookieCharcoalStaticVariant } from "./bookie-charcoal-static";
import { BookieRoseStaticVariant } from "./bookie-rose-static";
import { BookieOliveStaticVariant } from "./bookie-olive-static";
import { BookieBurgundyStaticVariant } from "./bookie-burgundy-static";
import { BookieJadeStaticVariant } from "./bookie-jade-static";
import { BookieSaffronStaticVariant } from "./bookie-saffron-static";
import { BookieOnyxStaticVariant } from "./bookie-onyx-static";
import { BookieChampagneStaticVariant } from "./bookie-champagne-static";
import { BookieForestStaticVariant } from "./bookie-forest-static";
import { BookieCoralStaticVariant } from "./bookie-coral-static";
import { BookiePlumStaticVariant } from "./bookie-plum-static";
import { BookieAzureStaticVariant } from "./bookie-azure-static";
// Round 10 — 2 new designer iframe-static templates
import { NikohStaticVariant } from "./nikoh-static";
import { WeddingIsComingStaticVariant } from "./wedding-is-coming-static";
// Round 11 — Buklama paper-diorama / tunnel-book template
import { BuklamaStaticVariant } from "./buklama-static";
// Round 12 — 2 designer watercolor wedding templates
import { GardenArchStaticVariant } from "./garden-arch-static";
import { MountainStaticVariant } from "./mountain-static";
// Round 13 — celestial night-sky wedding template
import { StarryNightStaticVariant } from "./starry-night-static";
// Round 14 — terracotta dried-floral wedding template
import { TerracottaStaticVariant } from "./terracotta-static";
// Round 15 — paper-cut tunnel-book fairy-tale wedding template
import { ErtakStaticVariant } from "./ertak-static";
// Round 16 — twilight fairy-tale tunnel-book wedding template
import { PariStaticVariant } from "./pari-static";
// Round 17 — kids' circus / carnival birthday template
import { SharlarStaticVariant } from "./sharlar-static";
// Round 18 — sweet kids garden-party birthday template
import { AsalariStaticVariant } from "./asalari-static";
// Round 19 — celestial-library storybook birthday keepsake
import { RumaysaStaticVariant } from "./rumaysa-static";
// Round 20 — autumn-marigold watercolor wedding invitation
import { MarigoldStaticVariant } from "./marigold-static";
// Round 21 — peacock-motif emerald nikoh invitation
import { TovusStaticVariant } from "./tovus-static";
// Round 22 — midnight-blue & gold "Tungi Saroy" wedding invitation
import { MidnightPalaceStaticVariant } from "./midnight-palace-static";
// Round 23 — night-to-day "Yomg'irdan so'ng" wedding invitation
import { YomgirStaticVariant } from "./yomgir-static";
// Round 24 — sunny-meadow "Yaylov" wedding invitation
import { YaylovStaticVariant } from "./yaylov-static";
// Round 25 — sakura-falls "Sakura" wedding invitation
import { SakuraStaticVariant } from "./sakura-static";
// Round 26 — book-open "Qog'oz ertagi" storybook wedding invitation
import { QogozStaticVariant } from "./qogoz-static";
// Round 27 — railway-journey "Oltin yo'l" wedding invitation
import { OltinYolStaticVariant } from "./oltin-yol-static";
// Round 28 — endless-sky "Cheksiz osmon" wedding invitation
import { OsmonStaticVariant } from "./osmon-static";
// Round 29 — four-seasons-scroll "To'rt fasl" wedding invitation
import { FasllarStaticVariant } from "./fasllar-static";
// Round 30 — wax-seal envelope reveal "Envelope" wedding invitation
import { EnvelopeStaticVariant } from "./envelope-static";

export type { VariantCtx, VariantProps } from "./types";
export {
  VariantEditorial,
  VariantMagazine,
  VariantPhotoLed,
  VariantCeremonial,
  VariantMinimal,
  VariantCelebration,
  VariantNewborn,
  VariantAgenda,
  VariantMemorial,
  BotanicalVariant,
  SeasideVariant,
  JubileeVariant,
  EngagementVariant,
  CelebrationSunnatVariant,
  AcademiaVariant,
  AdultBirthdayVariant,
  LaunchEventVariant,
  ReverentVariant,
  RestaurantOpeningVariant,
};

// ═══════════════════════════════════════════════════════════════════════
// Dispatcher — keys MUST match TemplateVariant union in lib/data.ts
// ═══════════════════════════════════════════════════════════════════════
export const GuestVariants: Record<string, React.FC<VariantProps>> = {
  editorial: VariantEditorial,
  magazine: VariantMagazine,
  photoled: VariantPhotoLed,
  ceremonial: VariantCeremonial,
  minimal: VariantMinimal,
  celebration: VariantCelebration,
  newborn: VariantNewborn,
  agenda: VariantAgenda,
  memorial: VariantMemorial,
  // 10 variants (round 2)
  botanical: BotanicalVariant,
  seaside: SeasideVariant,
  jubilee: JubileeVariant,
  engagement: EngagementVariant,
  "celebration-sunnat": CelebrationSunnatVariant,
  academia: AcademiaVariant,
  "adult-birthday": AdultBirthdayVariant,
  "launch-event": LaunchEventVariant,
  reverent: ReverentVariant,
  "restaurant-opening": RestaurantOpeningVariant,
  // 10 variants (round 3)
  "corp-anniversary": CorpAnniversaryVariant,
  "retail-opening": RetailOpeningVariant,
  "conf-tracks": ConfTracksVariant,
  masterclass: MasterclassVariant,
  "charity-elegant": CharityElegantVariant,
  housewarming: HousewarmingVariant,
  "sunrise-wedding": SunriseWeddingVariant,
  "milestone-birthday": MilestoneBirthdayVariant,
  lovers: LoversVariant,
  iftar: IftarVariant,
  // 5 variants (round 4 — wedding maximalist)
  "baroque-gold": BaroqueGoldVariant,
  "tulip-miniature": TulipMiniatureVariant,
  "celestial-foil": CelestialFoilVariant,
  "garden-cascade": GardenCascadeVariant,
  "bukhara-royal": BukharaRoyalVariant,
  // 5 variants (round 5 — birthday maximalist)
  "kid-carnival": KidCarnivalVariant,
  "princess-castle": PrincessCastleVariant,
  "sparkler-milestone": SparklerMilestoneVariant,
  "vintage-fair": VintageFairVariant,
  "disco-neon": DiscoNeonVariant,
  // User-imported standalone HTML templates
  "diyora-static": DiyoraStaticVariant,
  "avgust-static": AvgustStaticVariant,
  "sentabr-static": SentabrStaticVariant,
  // Round 6 — 10 mobile-first iframe-static wedding templates
  "mehrli-static": MehrliStaticVariant,
  "tilakli-static": TilakliStaticVariant,
  "olovgul-static": OlovgulStaticVariant,
  "bezakli-static": BezakliStaticVariant,
  "ipakli-static": IpakliStaticVariant,
  "sokin-static": SokinStaticVariant,
  "mavjli-static": MavjliStaticVariant,
  "lavanda-static": LavandaStaticVariant,
  "olcha-static": OlchaStaticVariant,
  "quyoshli-static": QuyoshliStaticVariant,
  "beshik-toyi-static": BeshikToyiStaticVariant,
  // Round 7 — 5 mixed iframe-static templates
  "yubiley-korporativ-static": YubileyKorporativStaticVariant,
  "uchrashuv-static": UchrashuvStaticVariant,
  "barakali-static": BarakaliStaticVariant,
  "alisher-muazzam-static": AlisherMuazzamStaticVariant,
  "anvar-masuma-static": AnvarMasumaStaticVariant,
  // Round 8 — 4 designer iframe-static templates
  "birthday-riso-static": BirthdayRisoStaticVariant,
  "corporate-quarterly-static": CorporateQuarterlyStaticVariant,
  "marry-me-one-question-static": MarryMeOneQuestionStaticVariant,
  "wedding-editorial-cinema-static": WeddingEditorialCinemaStaticVariant,
  // Round 9 — 25 bookie-style templates (premium category)
  "bookie-paper-gold-static": BookiePaperGoldStaticVariant,
  "bookie-sage-static": BookieSageStaticVariant,
  "bookie-wine-static": BookieWineStaticVariant,
  "bookie-teal-static": BookieTealStaticVariant,
  "bookie-midnight-static": BookieMidnightStaticVariant,
  "bookie-copper-static": BookieCopperStaticVariant,
  "bookie-mauve-static": BookieMauveStaticVariant,
  "bookie-emerald-static": BookieEmeraldStaticVariant,
  "bookie-blush-static": BookieBlushStaticVariant,
  "bookie-navy-static": BookieNavyStaticVariant,
  "bookie-amber-static": BookieAmberStaticVariant,
  "bookie-pearl-static": BookiePearlStaticVariant,
  "bookie-terracotta-static": BookieTerracottaStaticVariant,
  "bookie-charcoal-static": BookieCharcoalStaticVariant,
  "bookie-rose-static": BookieRoseStaticVariant,
  "bookie-olive-static": BookieOliveStaticVariant,
  "bookie-burgundy-static": BookieBurgundyStaticVariant,
  "bookie-jade-static": BookieJadeStaticVariant,
  "bookie-saffron-static": BookieSaffronStaticVariant,
  "bookie-onyx-static": BookieOnyxStaticVariant,
  "bookie-champagne-static": BookieChampagneStaticVariant,
  "bookie-forest-static": BookieForestStaticVariant,
  "bookie-coral-static": BookieCoralStaticVariant,
  "bookie-plum-static": BookiePlumStaticVariant,
  "bookie-azure-static": BookieAzureStaticVariant,
  // Round 10 — 2 new designer iframe-static templates
  "nikoh-static": NikohStaticVariant,
  "wedding-is-coming-static": WeddingIsComingStaticVariant,
  // Round 11 — Buklama paper-diorama / tunnel-book template
  "buklama-static": BuklamaStaticVariant,
  // Round 12 — 2 designer watercolor wedding templates
  "garden-arch-static": GardenArchStaticVariant,
  "mountain-static": MountainStaticVariant,
  // Round 13 — celestial night-sky wedding template
  "starry-night-static": StarryNightStaticVariant,
  // Round 14 — terracotta dried-floral wedding template
  "terracotta-static": TerracottaStaticVariant,
  // Round 15 — paper-cut tunnel-book fairy-tale wedding template
  "ertak-static": ErtakStaticVariant,
  // Round 16 — twilight fairy-tale tunnel-book wedding template
  "pari-static": PariStaticVariant,
  // Round 17 — kids' circus / carnival birthday template
  "sharlar-static": SharlarStaticVariant,
  // Round 18 — sweet kids garden-party birthday template
  "asalari-static": AsalariStaticVariant,
  // Round 19 — celestial-library storybook birthday keepsake
  "rumaysa-static": RumaysaStaticVariant,
  // Round 20 — autumn-marigold watercolor wedding invitation
  "marigold-static": MarigoldStaticVariant,
  // Round 21 — peacock-motif emerald nikoh invitation
  "tovus-static": TovusStaticVariant,
  // Round 22 — midnight-blue & gold "Tungi Saroy" wedding invitation
  "midnight-palace-static": MidnightPalaceStaticVariant,
  // Round 23 — night-to-day "Yomg'irdan so'ng" wedding invitation
  "yomgir-static": YomgirStaticVariant,
  // Round 24 — sunny-meadow "Yaylov" wedding invitation
  "yaylov-static": YaylovStaticVariant,
  // Round 25 — sakura-falls "Sakura" wedding invitation
  "sakura-static": SakuraStaticVariant,
  // Round 26 — book-open "Qog'oz ertagi" storybook wedding invitation
  "qogoz-static": QogozStaticVariant,
  // Round 27 — railway-journey "Oltin yo'l" wedding invitation
  "oltin-yol-static": OltinYolStaticVariant,
  // Round 28 — endless-sky "Cheksiz osmon" wedding invitation
  "osmon-static": OsmonStaticVariant,
  // Round 29 — four-seasons-scroll "To'rt fasl" wedding invitation
  "fasllar-static": FasllarStaticVariant,
  // Round 30 — wax-seal envelope reveal "Envelope" wedding invitation
  "envelope-static": EnvelopeStaticVariant,
};
